var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M9.999 14.667a2 2 0 100-4 2 2 0 000 4zM13.999 18.667l-2-2.667-4 5.333h16l-6-8-4 5.334z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M27.2 5H4.8C3.256 5 2 6.233 2 7.75v16.5C2 25.767 3.256 27 4.8 27h22.4c1.544 0 2.8-1.233 2.8-2.75V7.75C30 6.233 28.744 5 27.2 5zM4.5 24.5C3.948 23.948 4 23 4 23V9s-.052-.948.5-1.5S6 7 6 7h20s.948-.052 1.5.5S28 9 28 9v14s.052.948-.5 1.5-1.5.5-1.5.5H6s-.948.052-1.5-.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDefault);
export default __webpack_public_path__ + "static/media/fileDefault.87971f37db00cbf0a65aa96ddaf8ac6b.svg";
export { ForwardRef as ReactComponent };